import { z } from 'zod';
import { TestModal, testModalSchema } from './TestModal';
import { JSXElementConstructor } from 'react';
import { DeleteJourneyModal, deleteJourneyModalSchema } from '../journey/DeleteJourneyModal';
import { EditMetricTemplateModal, editMetricTemplateModalSchema } from '../connections/metrics/MetricTemplates/EditMetricTemplateModal';
import {
	DeleteMetricTemplateModal,
	deleteMetricTemplateModalSchema,
} from '../connections/metrics/MetricTemplates/DeleteMetricTemplateModal';
import { DeleteMetricModal, deleteMetricModalSchema } from '../connections/metrics/DeleteMetricModal';
import { CreateMetricModal, createMetricModalSchema } from '../connections/metrics/createMetricModal/CreateMetricModal';
import { DeleteDataPointModal, deleteDataPointModalSchema } from '../connections/dataPoints/DeleteDataPointModal';
import { EditDataPointModal, editDataPointModalSchema } from '../connections/dataPoints/EditDataPointModal';
import { DeletePersonaModal, deletePersonaModalSchema } from '../persona/DeletePersonaModal';
import { DeleteTeamModal, deleteTeamModalSchema } from '../settings/organization/members/teams/DeleteTeamModal';
import { CreatePhaseModal, createPhaseModalSchema } from '../journey/detail/CreatePhaseModal';
import { DeletePersonaBlockModal, deletePersonaBlockModalSchema } from '../persona/detail/DeletePersonaBlockModal';
import { DeletePhaseModal, deletePhaseModalSchema } from '../journey/DeletePhaseModal';
import { DeleteActivityModal, deleteActivityModalSchema } from '../journey/DeleteActivityModal';
import { CreateJourneyModal, createJourneyModalSchema } from '../journey/create/CreateJourneyModal';
import { EditJourneyModal, editJourneyModalSchema } from '../journey/EditJourneyModal';
import { DeleteProfilePhotoModal, deleteProfilePhotoModalSchema } from '../settings/profile/DeleteProfilePhotoModal';
import { RemovePersonaAvatarModal, removePersonaAvatarModalSchema } from '../persona/detail/RemovePersonaAvatarModal';
import { createPersonaModalSchema, PersonaCreate } from '../persona/list/PersonaCreate';
import { createPersonaBlockModalSchema, PersonaBlockCreate } from '../persona/detail/PersonaBlockCreate';
import { PersonaBlockUpdate, updatePersonaBlockModalSchema } from '../persona/detail/PersonaBlockUpdate';
import { DeleteOpportunityModal, deleteOpportunityModalSchema } from '../opportunities/detail/DeleteOpportunityModal';
import { InviteMembersModal, inviteMembersModalSchema } from '../settings/organization/members/members/InviteMembersModal';
import { DeleteActionModal, deleteActionModalSchema } from '../actions/detail/DeleteActionModal';
import { EditWidgetNameModal, editWidgetNameModalSchema } from '../journey/detail/detailView/EditWidgetNameModal';
import { AddActionModal, addActionModalSchema } from '../opportunities/AddActionModal';
import { AddOpportunityModal, addOpportunityModalSchema } from '../actions/AddOpportunityModal';
import { CreateActivityModal, CreateActivityModalSchema } from '../journey/detail/CreateActivityModal';
import {
	CreateOpportunityAndAddToActivityModal,
	createOpportunityAndAddToActivityModalSchema,
} from '../journey/detail/detailView/widgets/opportunities/CreateOpportunityAndAddToActivityModal';
import {
	CreateActionAndAddToActivityModal,
	createActionAndAddToActivityModalSchema,
} from '../journey/detail/detailView/widgets/actions/CreateActionAndAddToActivityModal';

import { TagsEdit } from '../journey/detail/detailView/widgets/tags/TagsEdit';
import { editTagSchema } from '../settings/organization/resources/tags/TagsResourcePage';
import { OrganizationCreate, createOrganizationModalSchema } from '../pages/main/settings/organization/OrganizationCreate';
import { OrganizationEdit, editOrganizationModalSchema } from '../pages/main/settings/organization/OrganizationEdit';
import { MetricAssignmentModal, metricAssignmentModalSchema } from '../connections/metrics/MetricAssignmentModal';
import { CreateActionModal, createActionModalSchema } from '../journey/planning/CreateActionModal';
import { ActionAssignmentModal, actionAssignmentModalSchema } from '../actions/detail/ActionAssignmentModal';
import { OpportunityAssignmentModal, opportunityAssignmentModalSchema } from '../opportunities/detail/OpportunityAssignmentModal';
import { GoogleSheetsModal, googleSheetsModalSchema } from '../connections/dataSources/GoogleSheetsModal';
import { AddMetricToDashboardModal, addMetricToDashboardModalSchema } from '../dashboard/AddMetricToDashboardModal';
import { DuplicateActivityModal, duplicateActivityModalModalSchema } from '../journey/DuplicateActivityModal';
import { MapUnmappedSheetsModal, mapUnmappedSheetsModalSchema } from '../connections/dataSources/google/MapUnmappedSheetsModal';

type Def<Props> = Readonly<{
	component: JSXElementConstructor<Props>;
	payload: z.Schema<Props>;
}>;

const modalDefinitions = {
	test: {
		component: TestModal,
		payload: testModalSchema,
	},
	createJourney: {
		component: CreateJourneyModal,
		payload: createJourneyModalSchema,
	},
	editJourney: {
		component: EditJourneyModal,
		payload: editJourneyModalSchema,
	},
	deleteJourney: {
		component: DeleteJourneyModal,
		payload: deleteJourneyModalSchema,
	},
	editMetricTemplate: {
		component: EditMetricTemplateModal,
		payload: editMetricTemplateModalSchema,
	},
	deleteMetricTemplate: {
		component: DeleteMetricTemplateModal,
		payload: deleteMetricTemplateModalSchema,
	},
	createMetric: {
		component: CreateMetricModal,
		payload: createMetricModalSchema,
	},
	deleteMetric: {
		component: DeleteMetricModal,
		payload: deleteMetricModalSchema,
	},
	metricAssignment: {
		component: MetricAssignmentModal,
		payload: metricAssignmentModalSchema,
	},
	actionAssignment: {
		component: ActionAssignmentModal,
		payload: actionAssignmentModalSchema,
	},
	opportunityAssignment: {
		component: OpportunityAssignmentModal,
		payload: opportunityAssignmentModalSchema,
	},
	editMetricDataPoint: {
		component: EditDataPointModal,
		payload: editDataPointModalSchema,
	},
	deleteMetricDataPoint: {
		component: DeleteDataPointModal,
		payload: deleteDataPointModalSchema,
	},
	createPersona: {
		component: PersonaCreate,
		payload: createPersonaModalSchema,
	},
	deletePersona: {
		component: DeletePersonaModal,
		payload: deletePersonaModalSchema,
	},
	deletePersonaBlock: {
		component: DeletePersonaBlockModal,
		payload: deletePersonaBlockModalSchema,
	},
	deleteTeam: {
		component: DeleteTeamModal,
		payload: deleteTeamModalSchema,
	},
	createPhase: {
		component: CreatePhaseModal,
		payload: createPhaseModalSchema,
	},
	deletePhase: {
		component: DeletePhaseModal,
		payload: deletePhaseModalSchema,
	},
	createActivity: {
		component: CreateActivityModal,
		payload: CreateActivityModalSchema,
	},
	deleteActivity: {
		component: DeleteActivityModal,
		payload: deleteActivityModalSchema,
	},
	duplicateActivity: {
		component: DuplicateActivityModal,
		payload: duplicateActivityModalModalSchema,
	},
	deleteProfilePhoto: {
		component: DeleteProfilePhotoModal,
		payload: deleteProfilePhotoModalSchema,
	},
	removePersonaAvatar: {
		component: RemovePersonaAvatarModal,
		payload: removePersonaAvatarModalSchema,
	},
	createPersonaBlock: {
		component: PersonaBlockCreate,
		payload: createPersonaBlockModalSchema,
	},
	updatePersonaBlock: {
		component: PersonaBlockUpdate,
		payload: updatePersonaBlockModalSchema,
	},
	deleteOpportunity: {
		component: DeleteOpportunityModal,
		payload: deleteOpportunityModalSchema,
	},
	addAction: {
		component: AddActionModal,
		payload: addActionModalSchema,
	},
	inviteMembers: {
		component: InviteMembersModal,
		payload: inviteMembersModalSchema,
	},
	deleteAction: {
		component: DeleteActionModal,
		payload: deleteActionModalSchema,
	},
	editWidgetName: {
		component: EditWidgetNameModal,
		payload: editWidgetNameModalSchema,
	},
	addOpportunity: {
		component: AddOpportunityModal,
		payload: addOpportunityModalSchema,
	},
	createOpportunityAndAddToActivity: {
		component: CreateOpportunityAndAddToActivityModal,
		payload: createOpportunityAndAddToActivityModalSchema,
	},
	createActionAndAddToActivity: {
		component: CreateActionAndAddToActivityModal,
		payload: createActionAndAddToActivityModalSchema,
	},
	editTags: {
		component: TagsEdit,
		payload: editTagSchema,
	},
	createOrganization: {
		component: OrganizationCreate,
		payload: createOrganizationModalSchema,
	},
	editOrganization: {
		component: OrganizationEdit,
		payload: editOrganizationModalSchema,
	},
	createAction: {
		component: CreateActionModal,
		payload: createActionModalSchema,
	},
	googleSheets: {
		component: GoogleSheetsModal,
		payload: googleSheetsModalSchema,
	},
	addMetricToDashboard: {
		component: AddMetricToDashboardModal,
		payload: addMetricToDashboardModalSchema,
	},
	mapUnmappedSheets: {
		component: MapUnmappedSheetsModal,
		payload: mapUnmappedSheetsModalSchema,
	},
} as const satisfies { [key: string]: Def<any> };

export type ModalKeys = keyof typeof modalDefinitions;

export { modalDefinitions };
